import { RouterProvider } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';
import { HelmetProvider } from 'react-helmet-async';
import { queryClient } from '@/lib/query/client';
import { router } from './router';
import { ErrorBoundary } from '@/components/shared/ErrorBoundary';
import { ThemeProvider } from '@/components/landing/ThemeProvider';
import { GlobalUploadManager } from '@/components/ui/GlobalUploadManager';

export function App() {
    return (
        <ErrorBoundary>
            <QueryClientProvider client={queryClient}>
                <HelmetProvider>
                    <ThemeProvider attribute="class" defaultTheme="light" enableSystem>
                        <RouterProvider router={router} />
                        <GlobalUploadManager />
                        <Toaster
                            position="top-right"
                            richColors
                            closeButton
                            expand={false}
                            duration={5000}
                        />
                    </ThemeProvider>
                </HelmetProvider>
            </QueryClientProvider>
        </ErrorBoundary>
    );
}